import React, {useContext, useEffect, useState} from 'react'
import GenericCustomButton from '../../genericComponents/GenericCustomButton';
import Icons from '../../assets/icons';
import { Headset, ShieldCheck } from 'lucide-react';
import ShortDemo from '../../assets/gif/short_demo.gif'
import { dispatchHandler } from '../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissionKey } from '../../helper/permissions';
import ListComponent from '../../genericComponents/ListComponent';
import { deleteCookie, getCookie } from '../../helper/genericFunction';
import { ReloadContext, UserDetailsContext } from '../../App';

const FirstLoginModal = (props) => {

    const {policyVersionData={}, closeModal, setRefreshPopup, openModal = "acceptPolicy"} = props;

    const dispatch = useDispatch();
    const {clearUserContext} = useContext(UserDetailsContext)
    const { handleDocumentStatusChange } = useContext(ReloadContext);

    const updatePolicyVersionData = useSelector(state => state?.authStore?.updatePolicyVersionData);

    const [currentStep, setCurrentStep] = useState(1);
    const [isChecked, setIsChecked] = useState(false);
    const [openHelpDropdown, setOpenHelpDropdown] = useState(false);

    useEffect(()=>{
        if(updatePolicyVersionData?.isSuccess) {
            setRefreshPopup(true);
            closeModal();
        }
    }, [updatePolicyVersionData?.isSuccess])

    const onLogout = async () => {
        let registrationJwt = getCookie('registrationJwt');
        // setLoading(true);
        dispatchHandler(dispatch, "userSessionCreateRequest", { token: sessionStorage.getItem('token') || "", flowType: "LOGGEDOUT" });
        deleteCookie('jwt')
        if(registrationJwt) {
            deleteCookie('registrationJwt')
        }
        sessionStorage?.clear();
        clearUserContext?.();
        setTimeout(() => {
            // setLoading(false);
            handleDocumentStatusChange();
        },1000);
    };


    const handleChange = (type, data) => {
        switch (type) {
            // case 'prev':
            //     // if(currentStep === 1) {
            //     //     onLogout();
            //     //     return;
            //     // }
            //     setCurrentStep(Math.max(1, currentStep - 1));
            //     if(currentStep === 3) {
            //         setIsChecked(false)
            //     }
            //     break;
            case 'next':
                // if(currentStep === 3 && isChecked) {
                    // Handle confirm action here, e.g., close modal, save settings, etc.
                    const payload = {
                        privacy_policy_url: policyVersionData?.privacy_policy_url,
                        policy_version: "2.0",
                        aup_url: policyVersionData?.aup_url,
                        eula_url: policyVersionData?.eula_url
                    }
                    dispatchHandler(dispatch, "updatePolicyVersionRequest", payload, getPermissionKey("common", "commonfunctionality", "view"))
                // } else {
                //     // Move to the next step
                //     setCurrentStep(Math.min(3, currentStep + 1));
                // }
                break;
            default:
                break;
        }
    }

    const renderContent = (type='welcome') => {
        // switch (currentStep) {
        //     case 1:
        //         return (
        //             <div className='p-[16px] flex-1 flex items-center gap-6'>
        //                 <div className='w-[44%] flex flex-col items-center justify-center text-center'>
        //                     <Icons.HelloHand className='shrink-0 mb-3'/>
        //                     <p className='mb-1.5 text-[24px] font-semibold text-fontBlack'>Welcome to Supplymint    </p>
        //                     <p className='mb-0 text-[13px] font-normal text-fontBlack'>Your workspace is ready. Everything you need to manage procurement, vendors or inventory, all at your fingertips.</p>
        //                 </div>
        //                 <div className='w-[56%]'>
        //                     <Icons.Workspace/>
        //                 </div>
        //             </div>
        //         );

        //     case 2:
        //         return (
        //             <div className='p-[16px] flex-1 flex items-center gap-20'>
        //                 <div className='w-1/2 flex flex-col items-center justify-center text-center'>
        //                     <Icons.BlueRocket className='shrink-0 mb-4'/>
        //                     <p className='mb-2 text-[24px] font-semibold text-fontBlack'>Designed for maximum efficiency, visibility at every step</p>
        //                     <p className='mb-0 text-xs font-normal text-fontBlack'>From purchase intent to final delivery, everything at one place. No more scattered emails or manual tracking.</p>
        //                 </div>
        //                 <div className='w-1/2 relative'>
        //                     <div className='bg-white h-[300px] w-[300px] absolute z-[0] bottom-[-40px] left-1/2 -translate-x-1/2 rounded-full'></div>

        //                     <div className="overflow-hidden h-full z-[1] relative">
        //                         <img
        //                             src={ShortDemo}
        //                             alt="Supplymint"
        //                             className="rounded-md w-full h-full object-cover object-center"
        //                         />
        //                     </div>
        //                 </div>
        //             </div>
        //         )
            
        //     case 3:
        //         return (
        //             <div className='p-[24px] flex-1 flex items-center gap-7'>
        //                 <div className='w-1/2 flex flex-col items-center justify-center text-center'>
        //                     <p className='mb-2 text-[24px] font-semibold text-fontBlack whitespace-nowrap'>Review Security & Compliance</p>
        //                     <p className='mb-4 text-[13px] font-normal text-fontBlack'>We prioritize your data integrity. Please review and accept our terms to ensure a secure environment for your operations.</p>
        //                     <div className='p-[20px] rounded-[5px] border border-borderSlateGrey flex items-center gap-1.5 bg-white w-[calc(100%-20px)] mx-auto'>
        //                         <label className="generic-checkbox !h-auto !whitespace-normal">
        //                             <input
        //                                 type="checkbox"
        //                                 checked={isChecked}
        //                                 onChange={() => setIsChecked(!isChecked)}
        //                                 // disabled={inputField?.isEditableVendor != 0}
        //                             />
        //                             <span className="checkmark1"></span>
        //                             <p className='mb-0 text-[13px] font-normal text-fontGrey text-start'><span className='text-[#FD3757]'>*</span>I agree to the 
        //                             <a target='_blank' className='ml-[4px] text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.eula_url}>End User License Agreement</a>, 
        //                             <a target='_blank' className='ml-[4px] text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.aup_url}>Acceptable Use Policy</a> & 
        //                             <a target='_blank' className='ml-[4px] text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.privacy_policy_url}>Privacy & Security Policy.</a></p>
        //                         </label>

        //                     </div>
        //                 </div>
        //                 <div className='w-1/2 shrink-0'><Icons.Security/></div>
        //             </div>
        //         )

        //     default:
        //         return null;
        // }
        switch (type) {
            case 'welcome':
                return (
                    <div className='p-[16px] flex-1 flex items-center gap-6'>
                        <div className='flex flex-col justify-center'>
                            <div className='mb-3 flex items-center gap-2'>
                                <Icons.HelloHand height={29} width={29} className='shrink-0'/>
                                <p className='text-[24px] font-semibold text-fontBlack'>Welcome to Supplymint</p>
                            </div>
                            <p className='mb-3 text-[13px] font-normal text-fontBlack'>We are thrilled to help you manage and secure your operations, while maintaining complete data integrity and trust across every step.</p>
                            <p className='mb-6 text-[13px] font-normal text-fontBlack'>Your enterprise data is kept <span className='font-semibold'>secure, private, and fully protected</span> with us.</p>
                            <p className='mb-0 text-xs text-fontBlack flex flex-wrap gap-x-1'>
                                <span className='text-[#FD3757]'>*</span>
                                Please, review & agree to 
                                <a target='_blank' className='text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.eula_url}>End User License Agreement</a>
                                ,
                                <a target='_blank' className='text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.aup_url}>Acceptable Use Policy</a> and
                                <a target='_blank' className='text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.privacy_policy_url}>Privacy & Security Policy.</a>
                            </p>
                        </div>
                        <div className='shrink-0 px-5'><Icons.Security2/></div>
                    </div>
                );

            case 'acceptPolicy':
                return (
                    <div className='p-[16px] flex-1 flex items-center gap-6'>
                        <div className='flex flex-col justify-center'>
                            <div className='mb-3 flex items-center gap-2'>
                                <div className='h-[31px] aspect-square flex items-center justify-center rounded-full bg-primary_light shrink-0'><ShieldCheck size={19} strokeWidth={1.5} className='text-primary shrink-0' /></div>
                                <p className='mb-0 text-[24px] font-semibold text-fontBlack'>Secure policy update</p>
                            </div>
                            <p className='mb-3 text-[13px] font-normal text-fontBlack'>We’ve updated our policies to better support how you manage and secure your operations, while maintaining complete data integrity and trust across every step.</p>
                            <p className='mb-6 text-[13px] font-normal text-fontBlack'>Your enterprise data is kept <span className='font-semibold'>secure, private, and fully protected</span> with us.</p>
                            <p className='mb-0 text-xs text-fontBlack flex flex-wrap gap-x-1'>
                                <span className='text-[#FD3757]'>*</span>
                                Please, review & agree to 
                                <a target='_blank' className='text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.eula_url}>End User License Agreement</a>
                                ,
                                <a target='_blank' className='text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.aup_url}>Acceptable Use Policy</a> and
                                <a target='_blank' className='text-[#5d5fef] underline hover:opacity-75' href={policyVersionData?.privacy_policy_url}>Privacy & Security Policy.</a>
                            </p>
                        </div>
                        <div className='shrink-0 px-5'><Icons.Security2/></div>
                    </div>
                );
        
            default:
                break;
        }
        
    };


  return (
    <div className='p-[12px] h-full space-y-3 flex flex-col'>
      <div
        className='flex-1 relative border border-borderSlateGrey rounded-md flex flex-col' 
        style={{background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #EDEDFF 100%)"}}
     >
        {renderContent(openModal === "firstLogin" ? 'welcome' : 'acceptPolicy')}
        
        {/* <div className='absolute top-[12px] left-[12px]'>
            <GenericCustomButton
                label={'Help'}
                leftIcon={<Headset size={14} color='#5D5FEF' />}
                className='px-2.5 py-1 text-xs flex items-center gap-1.5 rounded-full border border-borderSlateGrey hover:opacity-75'
                onClick={()=>setOpenHelpDropdown(!openHelpDropdown)}
            />
            {openHelpDropdown && 
            <>
            <div className='fixed top-0 left-0 bottom-0 right-0 w-screen h-screen z-[4]' onClick={()=>setOpenHelpDropdown(false)}></div>
            <ListComponent
                modalMainClass='helpDropdown relative !z-[5] !top-full !left-0 mt-1 !min-w-[193px]'
                label={{
                    content: "Help & Support",
                }}
                // closeModal = {() => handleClickOutside()}
                headerKeys={{
                    "help": {}
                }}
                itemKeys={{
                    "help": ["label", "support"],
                }}
                getListData={() => ([
                    { label: "New Ticket", support: "Create New Support Ticket", onClick: () => { window.open("https://help.supplymint.com/support/tickets/new") } },
                    // { label: "Support Documentation", support: "Supplymint Help Portal", onClick: () => { window.open("https://support.supplymint.com/") } },
                    { label: "Blogs", support: "Get Latest News & Updates", onClick: () => { window.open("https://www.supplymint.com/blogs/") } },
                    { label: "Contact Us", support: "We'll Respond As Quick As Possible", onClick: () => { window.open("https://www.supplymint.com/contact") } },
                ])}
                submitHandler={(data) => data?.onClick?.()}
            />
            </>
            }
        </div> */}
      </div>
      <div className='flex items-center justify-end gap-5'>
        {/* <div className="flex gap-1">
        {[1,2,3].map((i) => (
            <div
            key={i}
            className={`h-[4px] cursor-pointer rounded-full transition-all duration-300
            ${currentStep === i ? "w-[20px] bg-slate-500" : "w-[6px] bg-gray-300"}`}
            onClick={()=>setCurrentStep(i)}
            />
        ))}
        </div> */}
        <div className='flex items-center gap-3'>
            {/* {currentStep > 1 && <GenericCustomButton
                type='outline'
                size='large'
                label="Back"
                onClick={() => handleChange('prev')}
                className='min-w-[100px]'
            />} */}
            <GenericCustomButton
                type='primary'
                size='large'
                // label={currentStep === 3 ? "Confirm" : "Continue"}
                label={'Agree & Continue'}
                onClick={() => handleChange('next')}
                rightIcon= {<Icons.RightBigArrow height={17} />}
                className='min-w-[230px]'
                // disabled={currentStep === 3 && !isChecked}
            />
        </div>
      </div>
    </div>
  )
}

export default FirstLoginModal
